<template>
  <div v-loading="loading" id="page" :element-loading-text="$t('confirm.generating_pdf')">
    <div v-if="!loading" class="success-message">
      <p>{{ $t('confirm.pdf_generated_success') }}</p>
    </div>
  </div>
</template>
<script>
import * as keyConvertUtils from "@/views/NEW/module/spec/config/jsonKeyConverter";
export default {
  name: "ERP-PreviewPDF",
  data() {
    return {
      loading:true
    };
  },
  created() {
    let itemCode = this.$route.query.itemCode;
    let lot = this.$route.query.lot;
    let productListType = this.$route.query.productListType || this.$route.query.type;
    let category = this.$route.query.category;
    let language = this.$route.query.language;
    let params = {
      itemCode: itemCode,
      lot: lot,
      productListType: productListType,
      category:category,
      language:language
    };
    this.loadData(params);
  },
  mounted() {},
  methods: {
    // 日期格式化函数，将日期字符串转为 MM/DD/YYYY 格式
    formatDateToMDY(dateStr) {
            if (!dateStr) return '';
            const date = new Date(dateStr);
            if (isNaN(date.getTime())) return dateStr; // 如果不是有效日期，返回原字符串
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            return `${mm}/${dd}/${yyyy}`;
    },
    loadData(params) {
      // spec: http://localhost:8083/#/erp-preview?itemCode=SDNP-P-C-011&productListType=products&category=spec&language=EN
      // sds: http://localhost:8083/#/erp-preview?itemCode=REXT-S-004&productListType=products&category=sds&language=EN
      // cn-sds: http://localhost:8083/#/erp-preview?itemCode=TYO-S-003&productListType=products&category=sds&language=CN
      // coa: http://localhost:8083/#/erp-preview?lot=xxxx&productListType=products&category=coa&language=CN
      
      let api = "";
      if(params.category=='spec'){
        api = this.$api.handleSpec.getNewSpecAuditedLatestInfo(params)
      }else if(params.category=='sds'){
        if(params.language=='EN'){
          api = this.$api.handleNewSds.getNewSdsAuditedLatestInfo(params);
        }else{
          api = this.$api.handleNewSds.getNewCnSdsAuditedLatestInfo(params);
        }
      }else if(params.category=='coa'){
        if(params.language=='EN'){
          api = this.$api.handleSpec.getNewCoaAuditedLatestInfo(params);
        }else{
          api = this.$api.handleSpec.getNewCnCoaAuditedLatestInfo(params);
        }
      }else{
        api = this.$api.handleSpec.getNewSpecAuditedLatestInfo(params)
      }
      
      api.then((res) => {
        let data = res;
        // 兼容返回格式为 { code, success, message, data, ... }
        if (data && typeof data === 'object' && ('code' in data) && ('data' in data)) {
          data = data.data;
        }

        console.log('data null:', data)
        // 判断 data 是否为空或 null
        if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
          this.$alert(this.$t('confirm.no_audit_record'), this.$t('confirm.tips'), {
            confirmButtonText: this.$t('confirm.ok'),
            type: 'warning',
            callback: () => {
              // 点击确认后关闭页面
              window.close();
            }
          });
          return;
        }
        if(params.category=='sds'){
          data = keyConvertUtils.convertJsonKeysToSnakeWithLodash(data);
          let jsonValueObj = keyConvertUtils.convertJsonKeysToSnakeWithLodash(JSON.parse(res.jsonValue));
          let jsonValueStr = JSON.stringify(jsonValueObj);
          data.json_value = jsonValueStr;
          data.revNumber=data.rev_number;
          data.verifiedTime=data.verified_time;
          console.log('data:',data)
        }else if(params.category=='coa'){
          if(data.verified!=1){
            this.$message.error({
              message: this.$t('confirm.no_verified_coa'),
              duration: 3000,
              onClose: () => {
                window.history.back();
              }
            });
            return;
          }
         
          data.json_value=data.jsonValue;
          data.item_code = data.itemCode || data.item_code;
        }else{
          data.json_value=data.jsonValue;
          data.item_code = data.itemCode;
        }
        if(data.createTime&&data.createTime!=''&&typeof(data.createTime)!='undefined'){
          data.createTime = this.formatDateToMDY(data.createTime);
        }else{
          data.createTime = data.create_time;
        }
        console.log('data.createTime:',data.createTime)
        if(data.verifiedTime&&data.verifiedTime!=''&&typeof(data.verifiedTime)!='undefined'){
          data.verifiedTime = this.formatDateToMDY(data.verifiedTime);
        }else{
          data.verifiedTime = data.verified_time;
        }
        data.verified_time = data.verifiedTime;
        
        
        data.create_time = data.createTime;
        data.rev_number = data.revNumber;
        this.previewHandle(data);
      });
    },
    previewHandle(data) {
      

      let category = this.$route.query.category;
      let language = this.$route.query.language;
      let lang = language=='CN'?'China':'US';
      
      let fileName = "";
      if(category == 'coa'){
        fileName = "erp_" + (data.lot || data.item_code); // 对于CoA使用lot号
      }else{
        fileName = "erp_" + data.item_code; // 对于spec/sds使用item_code
      }
      fileName = fileName.replace(":"," to ");
      let params = {
        language: lang,
        print_type: category,
        data: data,
        cutomer_signature: false,
        preview_pdf: false,
        file_name: fileName,
        response_type: "text",
      };
      console.log('params:',params)

      this.$axios
        .post("https://spec.dracoherbs.com/flask/generate_spec", params, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          let fileUrl = `https://spec.dracoherbs.com/download/${response.data.file_name}`;
          console.log('fileUrl:',fileUrl)
          setTimeout(() => {
            this.loading = false;
            // 在当前页面打开PDF文件
            window.location.href = fileUrl;
          }, 200);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
          this.$message.error({
            message: this.$t('confirm.save_fail'),
            duration: 3000,
            onClose: () => {
              window.history.back();
            }
          });
        });
    },
  },
};
</script>

<style>
#page{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-message {
  text-align: center;
  padding: 20px;
  background: #f0f9ff;
  border: 1px solid #0ea5e9;
  border-radius: 8px;
  color: #0369a1;
  font-size: 16px;
  max-width: 400px;
}

.success-message p {
  margin: 0;
  line-height: 1.5;
}
</style>